import { render, staticRenderFns } from "./RejectCommand.vue?vue&type=template&id=35201276&scoped=true&"
import script from "./RejectCommand.vue?vue&type=script&lang=ts&"
export * from "./RejectCommand.vue?vue&type=script&lang=ts&"
import style0 from "./RejectCommand.vue?vue&type=style&index=0&id=35201276&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35201276",
  null
  
)

export default component.exports